
<template>



    <span v-show="FinalVisible">
        <input ref="Element"
               type="checkbox" v-model="m_Value"
               :disabled="(!FinalEnabled)"
               :readonly="FinalReadOnly"
               @click="OnValueChange" />


    </span>


</template>

<script scoped>
    import TControlBase from '@/Common/TControlBase';

    export default {
        name: "t-checkbox",
        data() {
            return {
                m_Value: false,
                m_Attribute: TControlBase.Attribute({
                        DataType:"boolean",
                        Nullable: false,
                        Enabled: true,
                        Visible: true,
                        ReadOnly: false,
                        MaxLength: null
                    }
                )
            }
        }
        ,
        props: [...TControlBase.BaseProps],


        computed: {
 
        }
        ,

        methods: {

            GetValue() {
                let checkedValue;

                if (this.$refs.Element.checked) {
                    checkedValue = true;
                }
                else {
                    checkedValue = false;
                }

                return checkedValue;
            },

            SetValue(val) {

                if (val == null) {
                    this.m_Value = null;
                    this.$refs.Element.checked = false;
                }
                else if (typeof (val) == "boolean") {
                    //this.$refs.Element.checked = val;
                    this.m_Value = val;
                }
                else {
                    //this.$refs.Element.checked = this.ConvertToBoolean(val);
                    this.m_Value = val
                }

            } ,

            OnValueChange(e) {
                this.DoOnValueChange(e);
                //let resultValue = "";

                //if (this.$refs.Element.checked) {
                //    this.ResultValue = true;
                //}
                //else {
                //    this.ResultValue = false;
                //}
 
                //this.$emit("input", this.ResultValue);
                //this.$emit("change", this.ResultValue);

                if (this.$parent.OnCheckboxChange != null) {
                    this.$parent.OnCheckboxChange(e);
                }
            },



        },

        mounted() {

            this.DoOnMounted();
        },

        beforeMounted() {

        },

        created() {
            TControlBase.call(this);

            // if (this.value != null) {
            //    if (this.value == "0") {
            //        this.ResultValue = false;
            //    }
            //    else if (this.value == "1") {
            //        this.ResultValue = true;
            //    }
            //    else {
            //        this.ResultValue = this.value;
            //    }
            //}
            //else {
            //    this.ResultValue = false;
            //}

            //if (this.Enabled == "true" || this.Enabled == true) {
            //    this.m_Attribute.Enabled = true;
            //}
            //else if (this.Enabled == "false" || this.Enabled == false) {
            //    this.m_Attribute.Enabled = false;
            //}
        },

        watch: {

 
            //value: function (newVal, oldVal) {
            //    this.DoOnWatchValueChange(newVal);
            //},

            //Attribute: function () {

            //},
        }


    }
</script>

 
